export default [
  {
    path: "/fichatecnica",
    name: "FichaTecnica",
    props: { homepage: true},
    component: () => import("../views/FichaTecnica.vue"),
    children: [
          {
            path: ":pesquisa",
            component: () => import("../views/FichaTecnica.vue"),
          }
        ]
  },
];
